export enum ConnectionTypes {
  Bank = 'bank',
  DebitCard = 'debitcard',
  Credit = 'credit',
  Email = 'email',
}

export enum FlexiblePaymentMethods {
  MultiplePaymentMethods = 'MultiplePaymentMethods',
  PartialPayment = 'PartialPayment',
  InstallmentPlan = 'InstallmentPlan',
}

export enum AccountStatus {
  Active = 'Active',
  InActive = 'Inactive',
}

export enum PermissionLabel {
  EFTCollectEnabled = 'Collect EFT',
  EFTSendEnabled = 'Send EFT',
  USDEFTCollectEnabled = 'Collect EFT - USD',
  USDEFTSendEnabled = 'Send EFT - USD',
  InteracMoneyRequestEnabled = 'Interac - Money Request',
  InteracBulkPayoutEnabled = 'Interac - Bulk Payout',
  GCMEnabled = 'Currency Exchange',
  PushToCardEnabled = 'OCT',
  RTRWithdrawEnabled = 'VoPayInstant',
  PortalTransactionCreation = 'Portal - Read/Write Transactions',
  PortalViewOnly = 'Portal - Readonly Transactions',
  AutoBalanceTransferEnabled = 'Auto Balance Transfer',
  PayLinkEnabled = 'PayLink',
  AddUserEnabled = 'Add User',
  MaxFundEFTAmount = 'EFT - Maximum Fund',
  MaxWithdrawEFTAmount = 'EFT - Maximum Withdrawal',
  MaxGCMAmount = 'Currency Exchange - Maximum Amount',
  MaxInteracMoneyAmount = 'Interac - Maximum Money Request',
  MaxInteracBulkPayoutAmount = 'Interac - Maximum Bulk Payout',
  MaxRTRWithdrawAmount = 'VoPayInstant - Maximum Amount',
  MaxPushToCardAmount = 'OCT - Maximum Amount',
  DailyLimitAmount = 'Daily Limit Amount',
  WeeklyLimitAmount = 'Weekly Limit Amount',
  MonthlyLimitAmount = 'Monthly Limit Amount',
  MonthlyTransactionLimit = 'Monthly Transaction Creation Limit',
  MaxACHFundAmount = 'ACH - Maximum Fund',
  MaxACHWithdrawAmount = 'ACH - Maximum Withdrawal',
  ACHFundEnabled = 'ACH Fund',
  ACHWithdrawEnabled = 'ACH Withdraw',
  MaxFundMyAccountAmount = 'Max Fund My Account',
  MaxWithdrawMyAccountAmount = 'Max Withdraw My Account',
  CreditCardEnabled = 'Credit Card',
  IQ11Enabled = 'IQ11',
  BrandingEmailEnabled = 'Email White Label',
  BrandingELinxEnabled = 'eLinx & Bank Verify White Label',
  BrandingOnboardingEnabled = 'Application Form White Label',
  BrandingPortalEnabled = 'VoPay Portal White Label',
  KYCLightEnabled = 'KYC Light',
}

export enum AccountUserPermissionsLabel {
  ViewSubaccounts = 'View Sub accounts',
  AddSubaccounts = 'Add Sub accounts',
  CreatePayments = 'Create Payments',
  CreateCollections = 'Create Collections',
  ViewBeneficiaries = 'View Contacts',
  AddBeneficiaries = 'Add Contacts',
  ViewBulkFileUpload = 'View Bulk File Upload',
  CreateBulkFileUpload = 'Create Bulk File Upload',
  ViewScheduledTransactions = 'View Scheduled Transactions',
  ViewTransactionHistory = 'View Transaction History',
  ViewSettings = 'View Settings',
  AddSettings = 'Add Settings',
  ViewUsers = 'View Users',
  AddUsers = 'Add Users',
  ApproveTransactions = 'Approve Transactions',
  ManageUserPermissions = 'Manage User Permissions',
  CreateAccountTransfer = 'Create Account Transfer',
  ViewClientAccounts = 'View Client Accounts',
  AddClientAccounts = 'Add Client Accounts',
  CreateClientAccountTransfers = 'Create Client Account Transfers',
  CreateConversions = 'Create Conversions',
  ManageDefaultPayments = 'Manage Default Payments',
  CreateSupportTickets = 'Create Support Tickets',
  ViewSupportTickets = 'View Support Tickets',
  ViewReconciliation = 'View Reconciliation',
  ViewAccountingBills = 'View Accounting Bills And Invoices',
  ProcessAccountingBills = 'Process Accounting Bills And Invoices',
  TransactionCancellation = 'Cancel Transaction',
  ViewTransactionApprovalWorkflow = 'View Transaction Approval Settings',
  CreateTransactionApprovalWorkflow = 'Create and Edit Transaction Approval Settings',
  ViewTransactionReport = 'View Transaction Report',
  CreateTransactionReport = 'Create Transaction Report',
  ManageTransactionGroups = 'Manage Transaction Groups',
  ManageInterestAccounts = 'Manage Interest Account',
  ViewInterestAccounts = 'View-Only Interest Account',
}

export enum AccountUserPermissionsId {
  ViewSubaccounts = 'ViewSubaccounts',
  AddSubaccounts = 'AddSubaccounts',
  CreatePayments = 'CreatePayments',
  CreateCollections = 'CreateCollections',
  ViewBeneficiaries = 'ViewBeneficiaries',
  AddBeneficiaries = 'AddBeneficiaries',
  ViewBulkFileUpload = 'ViewBulkFileUpload',
  CreateBulkFileUpload = 'CreateBulkFileUpload',
  ViewScheduledTransactions = 'ViewScheduledTransactions',
  ViewTransactionHistory = 'ViewTransactionHistory',
  ViewSettings = 'ViewSettings',
  AddSettings = 'AddSettings',
  ViewUsers = 'ViewUsers',
  AddUsers = 'AddUsers',
  ApproveTransactions = 'ApproveTransactions',
  ManageUserPermissions = 'ManageUserPermissions',
  CreateAccountTransfer = 'CreateAccountTransfer',
  ViewClientAccounts = 'ViewClientAccounts',
  AddClientAccounts = 'AddClientAccounts',
  CreateClientAccountTransfers = 'CreateClientAccountTransfers',
  CreateConversions = 'CreateConversions',
  ManageDefaultPayments = 'ManageDefaultPayments',
  CreateSupportTickets = 'CreateSupportTickets',
  ViewSupportTickets = 'ViewSupportTickets',
  ViewReconciliation = 'ViewReconciliation',
  ViewAccountingBills = 'ViewAccountingBillsAndInvoices',
  ProcessAccountingBills = 'ProcessAccountingBillsAndInvoices',
  TransactionCancellation = 'TransactionCancellation',
  ViewTransactionApprovalWorkflow = 'ViewTransactionApprovalWorkflow',
  CreateTransactionApprovalWorkflow = 'CreateTransactionApprovalWorkflow',
  ViewTransactionReport = 'ViewTransactionReport',
  CreateTransactionReport = 'CreateTransactionReport',
  ManageTransactionGroups = 'ManageTransactionGroups',
  ManageInterestAccounts = 'ManageInterestAccounts',
  ViewInterestAccounts = 'ViewInterestAccounts',
  ViewBankAccountTransactionHistory = 'ViewBankAccountTransactionHistory',
  ViewElinxSettings = 'ViewElinxSettings',
}

export enum CreateTicketId {
  AccountName = 'AccountName',
  CcEmails = 'CcEmails',
  TicketSubject = 'TicketSubject',
  TicketContent = 'TicketContent',
  TicketCategory = 'TicketCategory',
  TransactionID = 'TransactionID',
  TicketAttachment = 'TicketAttachment',
  TicketRequesterName = 'TicketRequesterName',
  TicketSubCategory = 'TicketSubCategory',
}

export enum CreateTicketCommentId {
  TicketComment = 'TicketComment',
  Files = 'files',
}

export enum PartnerAccountTransferId {
  TransferTypeID = 'TransferTypeID',
  DebitorAccountID = 'DebitorAccountID',
  RecipientAccountID = 'RecipientAccountID',
  Currency = 'Currency',
  Amount = 'Amount',
  ClientReferenceNumber = 'ClientReferenceNumber',
  Notes = 'Notes',
}

export enum FileUploadId {
  Service = 'Service',
  Product = 'Product',
  Currency = 'Currency',
  FileName = 'FileName',
  FileBase64 = 'FileBase64',
}
export enum FileUploadLabel {
  Service = 'Service',
  Product = 'Product',
  Currency = 'Choose Currency',
  FileName = 'File',
  FileBase64 = 'File',
}
export enum FileTemplateId {
  Service = 'Service',
  Product = 'Product',
  Currency = 'Currency',
}
export enum FileTemplateLabel {
  Service = 'Service',
  Product = 'Product',
  Currency = 'Choose Currency',
}

export enum CreateLeadId {
  FirstName = 'FirstName',
  LastName = 'LastName',
  BusinessEmailAddress = 'BusinessEmail',
  CompanyName = 'CompanyName',
  DoingBusinessAs = 'DBA',
  WebsiteURL = 'websiteURL',
  BusinessModel = 'businessModel',
  Comments = 'Comments',
}

export enum CreateInsideSalesLeadId {
  PartnerID = 'PartnerID',
  AgentID = 'AgentID',
}

export enum CreateISOLeadId {
  DataAggregator = 'DataAggregator',
  SystemOfRecord = 'SystemOfRecord',
}

export enum CreateInsideSalesLeadLabel {
  PartnerID = 'Partner ID',
  AgentID = 'Agent ID',
}

export enum CreateISOLeadLabel {
  DataAggregator = 'Data Aggregator',
  SystemOfRecord = 'System Of Record',
}

export enum ChangeUserPasswordId {
  NewPassword = 'NewPassword',
}

export enum ChangeUserRoleId {
  Role = 'Role',
}

export enum ChangeClientUserPasswordId {
  NewPassword = 'newPassword',
}
export enum ChangeClientUserPasswordLabel {
  NewPassword = 'New Password',
}

export enum AddUserId {
  EmailAddress = 'EmailAddress',
}

export enum AddUserLabel {
  EmailAddress = 'Email Address',
}

export enum ChangePasswordId {
  NewPassword = 'NewPassword',
}

export enum ChangePasswordLabel {
  NewPassword = 'New Password',
}

export enum CreateUserId {
  EmailAddress = 'EmailAddress',
  Role = 'Role',
}

export enum DeleteUserId {
  EmailAddress = 'EmailAddress',
}

export enum DeleteUserLabel {
  EmailAddress = 'Email Address',
}

export enum EditSignerId {
  AuthorizedFullLegalName = 'AuthorizedFullLegalName',
  AuthorizedEmailAddress = 'AuthorizedEmailAddress',
  AuthorizedOccupation = 'AuthorizedOccupation',
}

export enum EditSignerLabel {
  AuthorizedFullLegalName = 'Full Name',
  AuthorizedEmailAddress = 'Email Address',
  AuthorizedOccupation = 'AuthorizedOccupation',
}

export enum AddSignerId {
  AuthorizedFullLegalName = 'AuthorizedFullLegalName',
  AuthorizedEmailAddress = 'AuthorizedEmailAddress',
  AuthorizedOccupation = 'AuthorizedOccupation',
}

export enum AddSignerLabel {
  AuthorizedFullLegalName = 'Full Name*',
  AuthorizedEmailAddress = 'Email Address*',
  AuthorizedOccupation = 'Title*',
}

export enum LoginFormId {
  EmailAddress = 'EmailAddress',
  Password = 'Password',
}

export enum LoginFormLabel {
  EmailAddress = 'Email',
  Password = 'Password',
}
export enum BankLoginFormId {
  Username = 'Username',
  Password = 'Password',
}

export enum BankLoginFormLabel {
  Username = 'Username',
  Password = 'Password',
}
export enum SecurityQuestionLabel {
  Answer = 'Answer',
}

export enum SecurityQuestionId {
  Answer = 'Answer',
}

export enum PersonalProfileId {
  FullName = 'FullName',
  EmailAddress = 'EmailAddress',
  PhoneNumber = 'PhoneNumber',
  Address = 'Address',
  Password = 'Password',
  ConfirmPassword = 'ConfirmPassword',
}

export enum PersonalProfileLabel {
  FullName = 'Full Name',
  EmailAddress = 'Email',
  PhoneNumber = 'Phone',
  Address = 'Address',
  Password = 'Password',
  ConfirmPassword = 'Confirm Password',
}

export enum BusinessProfileId {
  CompanyName = 'CompanyName',
  EmailAddress = 'EmailAddress',
  PhoneNumber = 'PhoneNumber',
  Address = 'Address',
  Password = 'Password',
  ConfirmPassword = 'ConfirmPassword',
}

export enum BusinessProfileLabel {
  CompanyName = 'Company Name',
  EmailAddress = 'Business Email',
  PhoneNumber = 'Phone',
  Address = 'Business Address',
  Password = 'Password',
  ConfirmPassword = 'Confirm Password',
}

export enum ManualBankAccountId {
  FirstName = 'FirstName',
  LastName = 'LastName',
  CompanyName = 'CompanyName',
  Email = 'EmailAddress',
  BranchTransitNumber = 'BranchTransitNumber',
  FinancialInstitutionNumber = 'FinancialInstitutionNumber',
  AccountNumber = 'AccountNumber',
  RoutingNumber = 'RoutingNumber',
  Currency = 'Currency',
  Address = 'Address',
  City = 'City',
  Province = 'Province',
  PostalCode = 'PostalCode',
  Country = 'Country',
}

export enum ManualBankAccountLabel {
  FirstName = 'First Name',
  LastName = 'Last Name',
  CompanyName = 'Company Name',
  Email = 'Email',
  BranchTransitNumber = 'Branch Transit Number',
  FinancialInstitutionNumber = 'Financial Institution Number',
  AccountNumber = 'Account Number',
  RoutingNumber = 'Routing Number',
  Currency = 'Currency',
}

export enum ManualBankAccountAddressId1 {
  Address1 = 'Address1',
  Address2 = 'Address2',
}

export enum ManualBankAccountAddressId2 {
  City = 'City',
  Province = 'Province',
  PostalCode = 'PostalCode',
}

export enum ManualBankAccountIdentificationId {
  PhoneNumber = 'PhoneNumber',
  IdentificationNumber = 'IdentificationNumber',
}

export enum OnlineBankAccountIdentificationId {
  IdentificationNumber = 'IdentificationNumber',
  FirstName = 'FirstName',
  LastName = 'LastName',
  CompanyName = 'CompanyName',
}

export enum CreditCardInfoLabel {
  FullName = 'Full Name',
  CardNumber = 'Card Number',
  ExpirationDate = 'Expiration Date',
  CVV = 'CVV',
}

export enum CreditCardInfoId {
  FullName = 'FullName',
  CardNumber = 'CardNumber',
  ExpirationDate = 'ExpirationDate',
  CVV = 'CVV',
}

export enum FundAccountId {
  Currency = 'Currency',
  PaymentMethod = 'PaymentMethod',
  Account = 'Account',
  Amount = 'Amount',
  ScheduleType = 'ScheduleType',
  TakeFromAccountOn = 'TakeFromAccountOn',
  Frequency = 'Frequency',
  SemiMonthlyDates = 'SemiMonthlyDates',
  StartDate = 'StartDate',
  Ending = 'Ending',
  EndDate = 'EndDate',
  Description = 'Description',
  MessageForRecipient = 'MessageForRecipient',
  Notes = 'Notes',
  EndingAfterPayments = 'EndingAfterPayments',
  ClientAccount = 'ClientAccount',
  TransactionLabel = 'TransactionLabel',
}

export enum TransferFundLabel {
  Currency = 'Currency',
  TransferType = 'Transfer Type',
  DebitorClientAccountID = 'Debitor Client Account',
  RecipientClientAccountID = 'Recipient(s) Client Account(s)',
  Amount = 'Total Amount',
  ScheduleType = 'Schedule Type',
  TakeFromAccountOn = 'Requested Transaction Date',
  Frequency = 'Frequency',
  SemiMonthlyDates = 'Semi-Monthly Dates',
  StartDate = 'Start Date',
  Ending = 'Ending',
  EndDate = 'End Date',
  EndingAfterPayments = 'Ending After Payments',
  Description = 'Description',
  ClientReferenceNumber = 'Client Reference Number',
  Notes = 'Notes',
  TransactionLabel = 'Transaction Label',
  SplitMethod = 'Split Method',
}

export enum TransferFundId {
  Currency = 'Currency',
  TransferType = 'TransferType',
  DebitorClientAccountID = 'DebitorClientAccountID',
  RecipientClientAccountID = 'RecipientClientAccountID',
  Amount = 'Amount',
  ScheduleType = 'ScheduleType',
  TakeFromAccountOn = 'TakeFromAccountOn',
  Frequency = 'Frequency',
  SemiMonthlyDates = 'SemiMonthlyDates',
  StartDate = 'StartDate',
  Ending = 'Ending',
  EndDate = 'EndDate',
  EndingAfterPayments = 'EndingAfterPayments',
  Description = 'Description',
  ClientReferenceNumber = 'ClientReferenceNumber',
  Notes = 'Notes',
  TransactionLabel = 'TransactionLabel',
  SplitMethod = 'SplitMethod',
}

export enum WithdrawAccountId {
  Currency = 'Currency',
  PaymentMethod = 'PaymentMethod',
  Account = 'Account',
  Amount = 'Amount',
  ScheduleType = 'ScheduleType',
  TakeFromAccountOn = 'TakeFromAccountOn',
  Frequency = 'Frequency',
  SemiMonthlyDates = 'SemiMonthlyDates',
  StartDate = 'StartDate',
  Ending = 'Ending',
  EndDate = 'EndDate',
  Description = 'Description',
  MessageForRecipient = 'MessageForRecipient',
  Notes = 'Notes',
  EndingAfterPayments = 'EndingAfterPayments',
  ClientAccount = 'ClientAccount',
  TransactionLabel = 'TransactionLabel',
}

export enum AddInteracLabel {
  etransferConnectionType = 'How will you send e-Transfers to this contact?',
  RecipientName = 'Recipient Name',
  RecipientPhoneNumber = 'Phone Number',
  RecipientEmailAddress = 'Email Address',
  Question = 'Security Question',
  Answer = 'Security Answer',
  ClientReferenceNumber = 'Client Refrence Number',
  Nickname = 'Nickname',
}

export enum AddInteracId {
  etransferConnectionType = 'etransferConnectionType',
  RecipientName = 'RecipientName',
  RecipientPhoneNumber = 'RecipientPhoneNumber',
  RecipientEmailAddress = 'RecipientEmailAddress',
  Question = 'Question',
  Answer = 'Answer',
  ClientReferenceNumber = 'ClientReferenceNumber',
  Nickname = 'Nickname',
}

export enum BankAccountTransferLabel {
  Currency = 'Currency',
  From = 'From',
  To = 'To',
  Amount = 'Amount',
}

export enum BankAccountTransferId {
  Currency = 'Currency',
  From = 'From',
  To = 'To',
  Amount = 'Amount',
}

export enum CreateAutoBalanceId {
  Currency = 'Currency',
  Account = 'Account',
  Balance = 'Balance',
  StartDate = 'StartDate',
  Frequency = 'Frequency',
}

export enum AccountPermissionsLabel {
  ViewOnly = 'View Only (No payment services enabled)',
  EFTCollectEnabled = 'EFT Collect Enabled',
  EFTSendEnabled = 'EFT Send Enabled',
  InteracMoneyRequestEnabled = '<i>Interac</i> Money Request<sup>&reg;</sup>',
  InteracBulkPayoutEnabled = 'Interac Bulk Payout Enabled',
}

export enum AccountPermissionsId {
  ViewOnly = 'ViewOnly',
  EFTCollectEnabled = 'EFTCollectEnabled',
  EFTSendEnabled = 'EFTSendEnabled',
  InteracMoneyRequestEnabled = 'InteracMoneyRequestEnabled',
  InteracBulkPayoutEnabled = 'InteracBulkPayoutEnabled',
}

export enum AccountTransferLabel {
  Currency = 'Currency',
  From = 'From',
  To = 'To',
  Amount = 'Amount',
}

export enum AccountTransferId {
  Currency = 'Currency',
  From = 'From',
  To = 'To',
  Amount = 'Amount',
}

export enum SubAccountCreationLabel {
  LegalBusinessName = 'Legal Business Name',
  AccountName = 'Account Name',
  OriginatorName = 'Statement Descriptor',
  OriginatorShortName = 'Statement Descriptor - Shortened',
  EmailAddress = 'Email',
  SendWelcomeEmail = 'Send Welcome Email?',
}

export enum SubAccountCreationId {
  LegalBusinessName = 'LegalBusinessName',
  OriginatorName = 'OriginatorName',
  OriginatorShortName = 'OriginatorShortName',
  EmailAddress = 'EmailAddress',
  SendWelcomeEmail = 'SendWelcomeEmail',
}

export enum SinglePaymentLabel {
  Currency = 'Currency',
  PaymentMethod = 'Payment Method',
  CancellationPeriod = 'Expiration Time',
  BankingPaymentRail = 'Payment Rail',
  Contact = 'Contact',
  Amount = 'Amount',
  ScheduleType = 'Schedule Type',
  TakeFromAccountOn = 'Requested Transaction Date',
  Frequency = 'Frequency',
  SemiMonthlyDates = 'Semi-Monthly Dates',
  StartDate = 'Start Date',
  Ending = 'Ending',
  EndDate = 'End Date',
  Description = 'Description',
  Message = 'Message For Recipient',
  Notes = 'Notes',
  ClientAccount = 'Client Account',
  EndingAfterPayments = 'Ending After Payments',
  TransactionLabel = 'Transaction Label',
  ClientReferenceNumber = 'Client Reference Number',
  FirstName = 'First Name',
  LastName = 'Last Name',
  Address1 = 'Address',
  Address2 = 'Unit',
  City = 'City',
  Province = 'Province',
  State = 'State',
  Country = 'Country',
  PostalCode = 'Postal Code',
  ZipCode = 'Zip Code',
  FinancialInstitutionNumber = 'Financial Institution Number',
  BranchTransitNumber = 'Branch / Transit Number',
  ABARoutingNumber = 'ABA Routing Number',
  AccountNumber = 'Account Number',
  ContactType = 'Contact Type',
  CompanyName = 'Business Name',
  EtransferConnectionType = 'How will you send e-Transfers to this contact?',
  RecipientName = 'Recipient Name',
  RecipientPhoneNumber = 'Phone Number',
  RecipientEmailAddress = 'Email Address',

  Question = 'Security Question',
  Answer = 'Security Answer',
  Nickname = 'Nickname',
  ProvideOrRequestPaymentInformation = 'Provide or Request Payment Information',
  AccountConnectionMethod = 'Account Connection Method',
  MessageForRecipient = 'Message to Recipient',
  InvoiceNumber = 'Invoice Number',
  SendEmail = 'Send Email',
  IdentificationNumber = "Federal Tax ID/Driver's License",
  SenderName = 'Sent By',
  RecipientNotifications = 'Recipient Notifications',
  RecipientReminders = 'Recipient Reminders',
  ReminderFreqeuncy = 'Set eLinx Reminder Frequency (Days)',
  NotificationMethod = 'Send eLinx Notification via',
  SecCode = 'SEC Code',
  AcceptedCardBrands = 'Accepted Card Brands',
  CardTypeValidation = 'Validate Card Type',
}

export enum SinglePaymentId {
  Currency = 'Currency',
  PaymentMethod = 'PaymentMethod',
  CancellationPeriod = 'CancellationPeriod',
  BankingPaymentRail = 'BankingPaymentRail',
  Contact = 'Contact',
  Amount = 'Amount',
  ScheduleType = 'ScheduleType',
  TakeFromAccountOn = 'TakeFromAccountOn',
  Frequency = 'Frequency',
  SemiMonthlyDates = 'SemiMonthlyDates',
  StartDate = 'StartDate',
  Ending = 'Ending',
  EndDate = 'EndDate',
  Description = 'Description',
  Message = 'Message',
  Notes = 'Notes',
  ClientAccount = 'ClientAccount',
  EndingAfterPayments = 'EndingAfterPayments',
  TransactionLabel = 'TransactionLabel',
  ClientReferenceNumber = 'ClientReferenceNumber',
  SecCode = 'SecCode',
  FirstName = 'FirstName',
  LastName = 'LastName',
  Address1 = 'Address1',
  Address2 = 'Address2',
  City = 'City',
  Province = 'Province',
  Country = 'Country',
  PostalCode = 'PostalCode',
  FinancialInstitutionNumber = 'FinancialInstitutionNumber',
  BranchTransitNumber = 'BranchTransitNumber',
  ABARoutingNumber = 'ABARoutingNumber',
  AccountNumber = 'AccountNumber',
  ContactType = 'ContactType',
  CompanyName = 'CompanyName',
  EtransferConnectionType = 'EtransferConnectionType',
  RecipientName = 'RecipientName',
  RecipientPhoneNumber = 'RecipientPhoneNumber',
  RecipientEmailAddress = 'RecipientEmailAddress',
  ReceiverPhoneNumber = 'ReceiverPhoneNumber',
  Question = 'Question',
  Answer = 'Answer',
  Nickname = 'Nickname',
  ProvideOrRequestPaymentInformation = 'ProvideOrRequestPaymentInformation',
  AccountConnectionMethod = 'AccountConnectionMethod',
  MessageForRecipient = 'MessageForRecipient',
  InvoiceNumber = 'InvoiceNumber',
  SendEmail = 'SendEmail',
  SenderName = 'SenderName',
  IdentificationNumber = 'IdentificationNumber',
  RecipientNotifications = 'SendNotification',
  RecipientReminders = 'SendReminder',
  ReminderFreqeuncy = 'ReminderFrequency',
  NotificationMethod = 'NotificationMethod',
  AcceptedCardBrands = 'AcceptedCardBrands',
  CardTypeValidation = 'CardTypeValidation',
}
export enum PaymentUpdateId {
  FinancialInstitutionNumber = 'FinancialInstitutionNumber',
  BankTransitNumber = 'BankTransitNumber',
  AccountNumber = 'AccountNumber',
  RoutingNumber = 'RoutingNumber',
  PhoneNumber = 'PhoneNumber',
  Address = 'Address',
  City = 'City',
  State = 'State',
  ZipCode = 'ZipCode',
  Email = 'Email',
  Phone = 'Phone',
  Question = 'Question',
  Answer = 'Answer',
  InteracMethod = 'InteracMethod',
  PaymentMethod = 'PaymentMethod',
  IdentificationNumber = 'IdentificationNumber',
  Language = 'Language',
  Date = 'PaymentDate',
}
export enum PaymentUpdateLabel {
  FinancialInstitutionNumber = 'Institution Number',
  BankTransitNumber = 'Branch / Transit Number',
  AccountNumber = 'Account Number',
  RoutingNumber = 'ABA Routing Number',
  Email = 'Email Address',
  PhoneNumber = 'Phone Number',
  Phone = 'Phone Number',
  Question = 'Security Question',
  Answer = 'Security Answer',
  InteracMethod = 'Email or Phone Number?',
  PaymentMethod = 'Payment Method',
  Address = 'Address',
  City = 'City',
  State = 'State',
  ZipCode = 'Zip Code',
  IdentificationNumber = 'Federal Tax ID',
  Language = 'Language',
  Date = 'Payment Date',
  CollectionMethodAmount = 'Collect From',
  PaymentMethodAmount = 'Pay To',
}

export enum PaymentInfoId {
  PaymentDate = 'PaymentDate',
  CreditNotes = 'CreditNotes',
  PaymentAmount = 'PaymentAmount',
  PaymentMethod = 'PaymentMethod',
}
export enum PaymentInfoLabel {
  PaymentMethod = 'Payment Method',
  CollectionMethodAmount = 'Collect From',
  PaymentMethodAmount = 'Pay To',
  CollectionAmount = 'Collection Amount',
  PaymentAmount = 'Payment Amount',
  CollectionDate = 'Collection Date',
  PaymentDate = 'Payment Date',
  PaymentCreditNotes = 'Apply Bill Credits',
  CollectionCreditNotes = 'Apply Invoice Credits',
}

export enum GroupCreationLabel {
  GroupName = 'Name',
  Description = 'Description',
  Service = 'Product',
  Currency = 'Currency',
}

export enum GroupCreationId {
  GroupName = 'GroupName',
  Description = 'Description',
  Service = 'Service',
  Currency = 'Currency',
}

export enum SingleCollectionLabel {
  Currency = 'Currency',
  PaymentMethod = 'Payment Method',
  BankingPaymentRail = 'Payment Rail',
  Contact = 'Contact',
  Amount = 'Amount',
  ScheduleType = 'Schedule Type',
  TakeFromAccountOn = 'Collection Date',
  Frequency = 'Frequency',
  SemiMonthlyDates = 'Semi-Monthly Dates',
  StartDate = 'Start Date',
  Ending = 'Ending',
  EndDate = 'End Date',
  Description = 'Description',
  Message = 'Message For Recipient',
  Notes = 'Notes',
  ClientAccount = 'Client Account',
  EndingAfterPayments = 'Ending After Payments',
  TransactionLabel = 'Transaction Label',
  ClientReferenceNumber = 'Client Reference Number',
  FirstName = 'First Name',
  LastName = 'Last Name',
  Address1 = 'Address',
  Address2 = 'Unit',
  City = 'City',
  Province = 'Province',
  Country = 'Country',
  PostalCode = 'Postal Code',
  ZipCode = 'Zip Code',
  State = 'State',
  FinancialInstitutionNumber = 'Financial Institution Number',
  BranchTransitNumber = 'Branch / Transit Number',
  ABARoutingNumber = 'ABA Routing Number',
  AccountNumber = 'Account Number',
  ContactType = 'Contact Type',
  CompanyName = 'Business Name',
  EtransferConnectionType = 'How will you send e-Transfers to this contact?',
  RecipientName = 'Recipient Name',
  RecipientPhoneNumber = 'Phone Number',
  RecipientEmailAddress = 'Email Address',
  Question = 'Security Question',
  Answer = 'Security Answer',
  Nickname = 'Nickname',
  ProvideOrRequestPaymentInformation = 'Provide or Request Payment Information',
  AccountConnectionMethod = 'Account Connection Method',
  MessageForRecipient = 'Message to Recipient',
  InvoiceNumber = 'Invoice Number',
  SendEmail = 'Send Email',
  IdentificationNumber = "Federal Tax ID/Driver's License",
  ContactName = 'Contact Name',
  SenderName = 'Sent By',
  RecipientNotifications = 'Recipient Notifications',
  RecipientReminders = 'Recipient Reminders',
  ReminderFreqeuncy = 'Set eLinx Reminder Frequency (Days)',
  NotificationMethod = 'Send eLinx Notification via',
  SecCode = 'SEC Code',
  AcceptedCardBrands = 'Accepted Card Brands',
  CardTypeValidation = 'Validate Card Type',
}

export enum SingleCollectionId {
  Currency = 'Currency',
  PaymentMethod = 'PaymentMethod',
  BankingPaymentRail = 'BankingPaymentRail',
  Contact = 'Contact',
  Amount = 'Amount',
  ScheduleType = 'ScheduleType',
  TakeFromAccountOn = 'TakeFromAccountOn',
  Frequency = 'Frequency',
  SemiMonthlyDates = 'SemiMonthlyDates',
  StartDate = 'StartDate',
  Ending = 'Ending',
  EndDate = 'EndDate',
  Description = 'Description',
  Message = 'Message',
  Notes = 'Notes',
  ClientAccount = 'ClientAccount',
  EndingAfterPayments = 'EndingAfterPayments',
  TransactionLabel = 'TransactionLabel',
  ClientReferenceNumber = 'ClientReferenceNumber',
  SecCode = 'SecCode',
  FirstName = 'FirstName',
  LastName = 'LastName',
  Address1 = 'Address1',
  Address2 = 'Address2',
  City = 'City',
  Province = 'Province',
  Country = 'Country',
  PostalCode = 'PostalCode',
  FinancialInstitutionNumber = 'FinancialInstitutionNumber',
  BranchTransitNumber = 'BranchTransitNumber',
  ABARoutingNumber = 'ABARoutingNumber',
  AccountNumber = 'AccountNumber',
  ContactType = 'ContactType',
  CompanyName = 'CompanyName',
  EtransferConnectionType = 'EtransferConnectionType',
  RecipientName = 'RecipientName',
  RecipientPhoneNumber = 'RecipientPhoneNumber',
  RecipientEmailAddress = 'RecipientEmailAddress',
  ReceiverPhoneNumber = 'ReceiverPhoneNumber',
  Question = 'Question',
  Answer = 'Answer',
  Nickname = 'Nickname',
  ProvideOrRequestPaymentInformation = 'ProvideOrRequestPaymentInformation',
  AccountConnectionMethod = 'AccountConnectionMethod',
  MessageForRecipient = 'MessageForRecipient',
  InvoiceNumber = 'InvoiceNumber',
  SendEmail = 'SendEmail',
  ContactName = 'ContactName',
  SenderName = 'SenderName',
  IdentificationNumber = 'IdentificationNumber',
  RecipientNotifications = 'SendNotification',
  RecipientReminders = 'SendReminder',
  ReminderFreqeuncy = 'ReminderFrequency',
  NotificationMethod = 'NotificationMethod',
  AcceptedCardBrands = 'AcceptedCardBrands',
  CardTypeValidation = 'CardTypeValidation',
}

export enum AccountCreationLabel {
  Currency = 'Currency',
  ClientType = 'Client Type',
  FirstName = 'First Name',
  LastName = 'Last Name',
  CompanyName = 'Company Name',
  DOB = 'Date of Birth',
  SINLastDigits = 'SIN - Last Four Digits',
  SSNLastDigits = 'SSN - Last Four Digits',
  Label = 'Label',
  EmailAddress = 'Email',
  PhoneNumber = 'Phone Number',
  ClientAccountID = 'Client Account ID',
  IdentificationNumber = 'Identification Number',
  Country = 'Country',
  Address1 = 'Address Line 1',
  Address2 = 'Address Line 2',
  City = 'City',
  Province = 'Province/State',
  PostalCode = 'Postal Code/Zip Code',
  BusinessName = 'Business Name',
  BusinessNumber = 'Business Number',
  BusinessWebsite = 'Business Website',
  BusinessPhone = 'Business Phone',
  BusinessTypeID = 'Business Type',
  BusinessTypeCategoryID = 'Business Category',
}

export enum AccountCreationId {
  Currency = 'Currency',
  ClientType = 'ClientType',
  FirstName = 'FirstName',
  LastName = 'LastName',
  CompanyName = 'CompanyName',
  DOB = 'DOB',
  SINLastDigits = 'SINLastDigits',
  EmailAddress = 'EmailAddress',
  PhoneNumber = 'PhoneNumber',
  ClientAccountID = 'ClientAccountID',
  IdentificationNumber = 'IdentificationNumber',
  Country = 'Country',
  Address1 = 'Address1',
  Address2 = 'Address2',
  City = 'City',
  Province = 'Province',
  PostalCode = 'PostalCode',
  BusinessName = 'BusinessName',
  BusinessNumber = 'BusinessNumber',
  BusinessWebsite = 'BusinessWebsite',
  BusinessPhone = 'BusinessPhone',
  BusinessTypeID = 'BusinessTypeID',
  BusinessTypeCategoryID = 'BusinessTypeCategoryID',
  Label = 'Label',
}
export enum CurrencySymbols {
  USD = '$',
  CAD = '$',
  GBP = '£',
  EUR = '€',
  AUD = '$',
  PLN = 'zł',
  DKK = 'Kr.',
  SEK = 'kr',
  NOK = 'kr',
}

export enum UpdateWebhookId {
  TransactionStatusWebHookURL = 'transaction',
  ElinxStatusWebHookURL = 'elinx',
  AccountStatusWebHookURL = 'accountonboarding',
  BatchRequestWebHookURL = 'batchrequest',
  BankAccountCreationWebHookURL = 'bankaccount',
  BatchDetailWebhookUrl = 'batchdetail',
  ScheduledTransactionsWebhookUrl = 'scheduledtransactions',
  AccountVerificationsWebhookUrl = 'accountverifications',
  TransactionGroupWebhookUrl = 'transactiongroup',
  AccountBalanceWebhookUrl = 'accountbalance',
  ClientAccountBalanceWebhookUrl = 'clientaccountbalance',
  PaymentReceivedWebhookUrl = 'paymentreceived',
  AccountLimitWebhookUrl = 'accountlimit',
  VirtualTransactionWebhookUrl = 'virtualtransaction',
  CreditCardConnectionWebhookUrl = 'creditcard',
  DebitCardConnectionWebhookUrl = 'debitcard',
}
export enum UpdateWebhookLabel {
  TransactionStatusWebHookURL = 'Transaction Status',
  ElinxStatusWebHookURL = 'eLinx Status',
  AccountStatusWebHookURL = 'Account Status',
  BatchRequestWebHookURL = 'Batch Requests',
  BankAccountCreationWebHookURL = 'Bank Account Creation',
  BatchDetailWebhookUrl = 'Batch Detail',
  ScheduledTransactionsWebhookUrl = 'Scheduled Transaction',
  AccountVerificationsWebhookUrl = 'Account Verification',
  TransactionGroupWebhookUrl = 'Transaction Group',
  AccountBalanceWebhookUrl = 'Account Balance',
  ClientAccountBalanceWebhookUrl = 'Client Account Balance',
  PaymentReceivedWebhookUrl = 'Payment Received',
  AccountLimitWebhookUrl = 'Account Limit',
  VirtualTransactionWebhookUrl = 'Virtual Accounts',
  CreditCardConnectionWebhookUrl = 'Credit Card Connection',
  DebitCardConnectionWebhookUrl = 'Debit Card Connection',
}
export enum RetriggerWebhookLabel {
  EventID = 'Webhook ID',
  Type = 'Webhook Type',
}
export enum RetriggerWebhookId {
  EventID = 'EventID',
  Type = 'Type',
}
export enum UpdateFlinksId {
  FlinksUrl = 'FlinksUrl',
}
export enum UpdateFlinksLabel {
  FlinksUrl = 'Flinks URL',
}

export enum UpdatePlaidId {
  PlaidClientID = 'PlaidClientID',
  PlaidSecretKey = 'PlaidSecretKey',
  PlaidUrl = 'PlaidUrl',
}
export enum UpdatePlaidLabel {
  PlaidClientID = 'Plaid Client ID',
  PlaidSecretKey = 'Plaid Secret Key',
  PlaidUrl = 'Plaid URL',
}
export enum UpdateInveriteId {
  InveriteAPIKey = 'InveriteAPIKey',
  InveriteUrl = 'InveriteUrl',
}
export enum UpdateInveriteLabel {
  InveriteAPIKey = 'Inverite API Key',
  InveriteUrl = 'Inverite URL',
}
export enum UpdateGlobalPaymentsId {
  GlobalPayAppID = 'GlobalPayAppID',
  GlobalPaySharedSecret = 'GlobalPaySharedSecret',
}
export enum UpdateGlobalPaymentsLabel {
  GlobalPayAppID = 'Global Pay App ID',
  GlobalPaySharedSecret = 'Global Pay Shared Secret',
}
export enum UpdateAuthorizedIpsId {
  AuthorizedIPs = 'AuthorizedIPs',
}
export enum UpdateAuthorizedIpsLabel {
  AuthorizedIPs = 'Comma separated list of IP Addresses',
}
export enum UpdateELinxId {
  EnableELinxDecline = 'IsDeclineEnabled',
  ReceiverNotifications = 'ReceiverNotifications',
  SenderNotifications = 'SenderNotifications',
  ELinxExpirationTime = 'TokenExpirationTime',
  ELinxSenderEmailAddress = 'SenderEmailAddress',
}
export enum UpdateELinxLabel {
  EnableELinxDecline = 'Allow user to decline',
  ReceiverNotifications = 'Send Notifications to the Recipient',
  SenderNotifications = 'Send Notifications to the Sender',
  ELinxExpirationTime = 'Token Expiration Time (days)',
  ELinxSenderEmailAddress = 'Sender Email Address',
}

export enum ELinxId {
  EnableELinxDecline = 'EnableELinxDecline',
  ELinxReminderEnabled = 'ELinxReminderEnabled',
  ReceiverNotificationsEnabled = 'ReceiverNotificationsEnabled',
  SenderNotificationsEnabled = 'SenderNotificationsEnabled',
  ELinxExpirationTime = 'ELinxExpirationTime',
  ELinxSenderEmailAddress = 'ELinxSenderEmailAddress',
}

// Onboarding Form
export enum OnboardingLoginId {
  EmailAddress = 'email',
}

export enum OnboardingLoginLabel {
  EmailAddress = 'Email Address',
}

export enum OnboardingAdminLoginId {
  EmailAddress = 'email',
  Password = 'password',
}

export enum OnboardingAdminLabel {
  EmailAddress = 'Email Address',
  Password = 'Password',
}

export enum OnboardingAuthenticationId {
  Code1 = 'Code1',
  Code2 = 'Code2',
  Code3 = 'Code3',
  Code4 = 'Code4',
  Code5 = 'Code5',
}

export enum CollaboratorFormLabel {
  collaboratorDropdown = 'Select Collaborator',
  name = 'Full Name',
  title = 'Position Title',
  email = 'Collaborator’s Business Email Address',
  formsId = 'Invite to Fill Out',
  documentsId = 'Invite to Fill Out',
  formAndDocuId = 'Invite to Fill Out',
}

export enum CollaboratorFormId {
  collaboratorDropdown = 'collaboratorDropdown',
  name = 'name',
  email = 'email',
  formsId = 'formsId',
  documentsId = 'documentsId',
  formAndDocuId = 'formAndDocuId',
}

export enum SignerPopupLabel {
  AuthorizedFullLegalName = 'Full Name',
  AuthorizedDOB = 'Date of Birth',
  AuthorizedOccupation = 'Position Title',
  AuthorizedEmailAddress = `Signer's Email Address`,
  AuthorizedAddress1 = 'Address Line 1',
  AuthorizedAddress2 = 'Address Line 2 (optional)',
  AuthorizedCity = 'City',
  AuthorizedProvince = 'Province/State',
  AuthorizedCountry = 'Country',
  AuthorizedPostalCode = 'Postal Code/Zip Code',
}

export enum SignerPopupId {
  AuthorizedFullLegalName = 'AuthorizedFullLegalName',
  AuthorizedDOB = 'AuthorizedDOB',
  AuthorizedOccupation = 'AuthorizedOccupation',
  AuthorizedEmailAddress = 'AuthorizedEmailAddress',
  AuthorizedAddress1 = 'AuthorizedAddress1',
  AuthorizedAddress2 = 'AuthorizedAddress2',
  AuthorizedCity = 'AuthorizedCity',
  AuthorizedProvince = 'AuthorizedProvince',
  AuthorizedCountry = 'AuthorizedCountry',
  AuthorizedPostalCode = 'AuthorizedPostalCode',
}

export enum CreateReportsLabel {
  RecipientEmail = 'Recipient Email',
  ReportName = 'Report Name',
  Description = 'Description',
  PaymentRails = 'Payment Rails',
  DateFormat = 'Date Format',
  ScheduleType = 'Schedule Type',
  DateRange = 'Date Range',
  AccountTransactionReportType = 'Report Type',
  IncludeSubAccounts = 'Include Sub-Accounts',
  IncludeGraph = 'Include Graph',
  DateRangeOption = 'Date Range Options',
}

export enum CreateReportsId {
  RecipientEmail = 'RecipientEmails',
  ReportName = 'ReportName',
  Description = 'Description',
  PaymentRails = 'PaymentRails',
  DateFormat = 'DateFormat',
  ScheduleType = 'ScheduleType',
  FromDate = 'FromDate',
  ToDate = 'ToDate',
  AccountTransactionReportType = 'AccountTransactionReportType',
  IncludeSubAccounts = 'IncludeSubAccounts',
  IncludeGraph = 'IncludeGraph',
  DateRangeOption = 'DateRangeOption',
}
export enum VerificationId {
  Amount1 = 'Amount1',
  Amount2 = 'Amount2',
}

export enum ElinxRequestId {
  SenderName = 'SenderName',
  ReceiverName = 'ReceiverName',
  PaymentSelectionMethod = 'PaymentSelectionMethod',
  AccountSelectionMethod = 'AccountSelectionMethod',
  Note = 'Note',
  InvoiceNumber = 'InvoiceNumber',
  SendEmail = 'SendEmail',
}
export enum BrandingId {
  PrimaryColor = 'PrimaryColor',
  SecondaryColor = 'SecondaryColor',
  Logo = 'Logo',
  SmallLogo = 'SmallLogo',
  ApplyToAll = 'ApplyToAll',
}

export enum BrandingType {
  Email = 'email',
  Elinx = 'elinx',
  Portal = 'portal',
  Onboarding = 'onboarding',
}

export enum PartialPaymentId {
  Amount = 'Amount',
  RemainderDate = 'RemainderDate',
}
